import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import jwtDecode from 'jwt-decode'
import PropTypes from 'prop-types'
import { fetchNewToken, logout, userSelector } from '../../../redux/features/user/userSlice'

const AuthenticationWrapper = ({ children }) => {
  const dispatch = useDispatch()
  const { token, refreshToken } = useSelector(userSelector)
  const [isValid, setIsValid] = useState(false)

  useEffect(() => {
    const tokenRefresh = () => {
      const payload = decodeJwtToken(token)
      if (!payload) {
        dispatch(logout())
        return
      }
      if (isJwtExpired(payload.exp, 0)) {
        dispatch(logout())
        return
      } else {
        setIsValid(true)
      }
      if (isJwtExpired(payload.exp, 1000 * 60 * 10)) {
        refresh().then(() => {
          setIsValid(true)
        }).catch((reason) => {
          console.log(reason)
        })
      }
    }

    const decodeJwtToken = (token) => {
      try {
        return jwtDecode(token)
      } catch (e) {
        return null
      }
    }

    const refresh = async () => {
      dispatch(fetchNewToken({ refreshToken }))
    }

    const isJwtExpired = (exp, withinNextMilliseconds = 0) => {
      if (isNaN(exp)) {
        return true
      }
      const expiration = new Date(exp * 1000)
      const now = new Date()
      return expiration.getTime() - now.getTime() < withinNextMilliseconds
    }

    const payload = decodeJwtToken(token)
    if (!payload) {
      dispatch(logout())
      return
    }
    if (isJwtExpired(payload.exp, 0)) {
      dispatch(logout())
      return
    } else {
      setIsValid(true)
    }

    const timer = window.setInterval(() => {
      tokenRefresh()
    }, 1000 * 60)
    setIsValid(true)

    return () => {
      clearInterval(timer)
    }
  }, [dispatch, token, refreshToken])

  return (
    <React.Fragment>{isValid ? children : null}</React.Fragment>
  )
}

AuthenticationWrapper.propTypes = {
  children: PropTypes.node,
}

export default AuthenticationWrapper
